import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Train = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 26H5C4.45 26 4 26.45 4 27C4 27.55 4.45 28 5 28H27C27.55 28 28 27.55 28 27C28 26.45 27.55 26 27 26Z" />
		<path d="M5 24H18.313C19.65 24 20.963 23.45 21.9 22.488L27.138 17.113C27.688 16.55 28.013 15.788 28.013 15C28.013 14.212 27.688 13.437 27.138 12.887L21.663 7.29902C19.6 5.19902 16.738 3.99902 13.8 3.99902H5C4.45 3.99902 4 4.44902 4 4.99902V22.999C4 23.549 4.45 23.999 5 23.999V24ZM21.5 10L25.425 14H16V10H21.5ZM13.8 6.00002C15.85 6.00002 17.863 6.72502 19.45 8.00002H15C14.45 8.00002 14 8.45002 14 9.00002V15C14 15.55 14.45 16 15 16H25.425L20.463 21.087C19.9 21.662 19.113 22 18.313 22H6V16H11C11.55 16 12 15.55 12 15V9.00002C12 8.45002 11.55 8.00002 11 8.00002H6V6.00002H13.8V6.00002ZM6 10H10V14H6V10Z" />
	</svg>
);

export default Train;
